// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseJSON = (jsonString = ''): any | undefined => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return undefined;
  }
};
